"use strict"

const bar = document.querySelector('.bar');
const visible = document.querySelector('.visible');
var prevScrollpos = window.pageYOffset;
window.addEventListener('scroll', function() {
  var currentScrollPos = window.pageYOffset;
  if (prevScrollpos > currentScrollPos) {
    bar.classList.add('visible');
  } else {
    bar.classList.remove('visible');
  }
  prevScrollpos = currentScrollPos;
});



var themeBtn = document.getElementById('themeBtn');
if (window.localStorage.getItem('dataMode') === undefined) {
  window.localStorage.setItem('dataMode', 'light');
}

var body = document.getElementById('up');
body.setAttribute('data-mode', window.localStorage.getItem('dataMode'));
themeBtn.addEventListener('click', function (e) {
  if (window.localStorage.getItem('dataMode') === 'light') {
    body.setAttribute('data-mode', 'dark');
    window.localStorage.setItem('dataMode', 'dark');
  } else {
    body.setAttribute('data-mode', 'light');
    window.localStorage.setItem('dataMode', 'light');
  }
});